module.exports = __webpack_public_path__ + "img/N220-2-EN.56edf149.png";